import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../utils/apollo/api'
import { usePlaceType } from '../_context/PlaceTypeContext'
import { useQuery } from '../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useLevelsState = () => React.useContext(Context) || {}
export const useLevels = () => useLevelsState()?.levels || []

const QUERY = gql`
  query Levels($filter: LevelFilter) {
    levels(filter: $filter) {
      id
      name
      enabled
    }
  }
`

const LevelsLoader = ({ children }) => {
  const type = usePlaceType()

  const { data, fetchMore, variables, ...state } = useQuery(QUERY, {
    variables: { filter: { types: [type] } },
    client: placesClient,
    fetchPolicy: 'cache-first'
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state}>{children}</StatePresenter>
    </Provider>
  )
}

export default LevelsLoader
